import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://groups-service.onyxcentersource.com',
  hostname: 'groups.onyxcentersource.com',

  logServices: {
    consoleLogSubscriber: {
      logLevel: 2
    },
    httpLogSubscriber: {
      logLevel: 0
    }
  }
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/environments/environment.prod.ts